import script from "./SkewedBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SkewedBox.vue?vue&type=script&setup=true&lang=js"

import "./SkewedBox.vue?vue&type=style&index=0&id=22c5f910&lang=scss"

const __exports__ = script;

export default __exports__